import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import ApperIcon from '@/components/ApperIcon';
import { normUsername } from '@/shared/referrals';
import { logReferralVisit, storeIncomingRef } from '@/shared/referralLink';

export const route = { path: '/r/:username', layout: 'public', access: 'public' };

/**
 * Where referral links land: remembers the friend's username for checkout, logs the visit
 * for the owner's Referrals page, then shows the plans.
 */
export default function RefLanding() {
  const { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const name = normUsername(decodeURIComponent(username || ''));
    if (!name) {
      navigate('/', { replace: true });
      return;
    }
    storeIncomingRef(name);
    logReferralVisit(name, `/r/${name}${document.referrer ? ` from ${document.referrer}` : ''}`);
    toast.success(`${name} sent you`, {
      description: 'Their username is saved and fills in at checkout when you order.',
    });
    navigate('/#plans', { replace: true });
  }, [username, navigate]);

  return (
    <div className="flex min-h-[50svh] items-center justify-center text-muted-foreground" role="status">
      <ApperIcon name="Loader2" size={20} className="mr-2 animate-spin" />
      Opening Ghost Cable…
    </div>
  );
}
